// @ts-nocheck
export const hotjarTrigger = (triggerId: string) => {
  if (window.hj) {
    window.hj('trigger', triggerId);
  }
};
